import ServiceRestApi from "./service-rest-api";

class SkillService {

    /**
     * Add new skill
     * @param {Object} payload
     * @returns Promise<HttpResponse>
     */
     addNewSkill = (payload) => {
        return ServiceRestApi.post(`/api/new-competence`, payload);
    }

    /**
     * Edit existing skill
     * @param {Object} payload 
     * @returns Promise<HttpResponse>
     */
    updateSkillItem = (payload) => {
        return ServiceRestApi.post(`/api/competence`, payload);
    }

    /**
     * Fetch skills items
     * @returns Promise<HttpResponse>
     */
    getSkillItems = () => {
        return ServiceRestApi.get(`/api/competences`);
    }

    /**
     * Delete skill item
     * @param {Number} id skill id to be deleted
     * @returns Promise<HttpResponse>
     */
    deleteSkillItem = (id) => {
        return ServiceRestApi.delete(`/api/competence?competenceId=${id}`)
    }

    /**
     * Fetch skills items
     * @returns promise<HttpResponse>
     */
    getSources = () => {
        return ServiceRestApi.get("api/sources");
    }
}
export default new SkillService();